import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Navbar from "./comonents/Navbar/Navbar";
import CommingSoon from "./comonents/ComingSoon";
import Login from "./comonents/Form/Login";
import Signup from "./comonents/Form/Signup";
import HireLawyer from "./comonents/HireLawyer";
import RegisterAsLawyer from "./comonents/RegisterAsLawyer";
import AskTheExpert from "./comonents/AskTheExpert";

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Route path="/" exact component={CommingSoon} />
        <Route path="/login" exact component={Login} />
        <Route path="/signup" exact component={Signup} />
        <Route path="/hirealawyer" exact component={HireLawyer} />
        <Route path="/registeraslawyer" exact component={RegisterAsLawyer} />
        <Route path="/asktheexpert" exact component={AskTheExpert} />
      </div>
    </Router>
  );
}

export default App;
